(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["back-to-top"] && !Shopify.designMode) return;
  try {
    

  window.addEventListener('scroll', function () {
      const element = document.querySelector('.back_to_top'); // Change this to your target element
      if (window.scrollY >= 400) {
        element.style.display = 'block';
      } else {
        element.style.display = 'none'; // Or 'flex', 'inline', etc. depending on your layout
      }
    });
  
  const topButtons = document.querySelector(".back_to_top");
      topButtons.addEventListener("click", () => {
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      });

  } catch(e) { console.error(e); }
})();
})();
